<template>
    <div class="Page">
        <!--Banner-->
        <section class="">
            <div class="banner">
                <h1 class="PageTitle" style="">OBTENIR UN PRIX</h1>
            </div>
            <div class="orangeStripe"></div>
        </section>
        <section>
            <form ref="formGetPrice" role="form" method="POST" action="https://reseaudynamique.com/ressources/api/emails.php" @submit.prevent="validateAndSubmit"> <!-- action="/<?php echo $NOMPAGE; ?>" --> 
                <v-row id="fourthBloc" class=" BGBloc4">
                    <v-col cols="12"><p class="electrikText">Formulaire pour obtenir un prix pour ton camion</p></v-col> 
                    <v-row class="grid boxForm form">
                        <input type="hidden" id="emailId" name="emailId" value="1"> 
                        <v-col cols="12" md="6" class="inputForm"> 
                            <input name="prenom" id="prenom" type="text" placeholder="Prénom" class="" v-model="form.prenom" required>  
                        </v-col>                        
                        <v-col cols="12" md="6" class="inputForm"> 
                            <input name="nom" id="nom" type="text" placeholder="Nom de famille" class="" v-model="form.nom" required> 
                        </v-col>
                        <v-col cols="12" md="6" class="inputForm"> 
                            <input name="villeEntreprise" id="villeEntreprise" type="text" placeholder="Ville de mon entreprise" class="" v-model="form.town" required> 
                        </v-col>
                        <v-col cols="12" md="6" class="inputForm"> 
                            <input name="email" id="email" type="email" placeholder="Courriel" class="" v-model="form.email" required>
                            <p v-if="errors.email" class="errorMsg">{{ errors.email }}</p>
                        </v-col>
                        <v-col cols="12" md="6" class="inputForm"> 
                            <input name="telephone" id="telephone" type="tel" placeholder="(514) 555-1234" class="" v-model="form.telephone" @input="formatTelephone" required>
                            <p v-if="errors.telephone" class="errorMsg">{{ errors.telephone }}</p>
                        </v-col>
                        <v-col cols="12" md="6" class="inputForm"> 
                            <input name="serialNumber" id="serialNumber" type="text" placeholder="Numéro de série" class="" v-model="form.serialNumber" required> 
                        </v-col>
                        <v-col cols="12" md="6" class="inputForm"> 
                            <select name="succursale" id="succursale" v-model="form.succursale" class="" required>
                                <option value="" disabled>Choisissez votre succursale</option>
                                <option v-for="(dealer, key) in dealers" :key="key" :value="dealer.town + ' - ' + dealer.name">{{ dealer.town }} - {{ dealer.name }}</option>
                            </select>
                        </v-col>
                        <v-col cols="12" md="6" class="inputForm">
                            <input name="comment" id="comment" type="text" placeholder="Commentaire" class="" v-model="form.comment">
                        </v-col>

                    </v-row>
                    <button type="submit" name="btnSendMail" id="btnSendMail" value="Envoyer" style=""><a>Soumettre</a></button>
                    <h2 v-if="sendForm == true" class="electrikText">Votre demande a bien été envoyée</h2>
                </v-row>
            </form>
        </section>

    </div>
</template>
<style scoped>
    .PageTitle { position: absolute; top: 50%; left: 50%; transform: translate(-50%,-50%); text-align: center; }
    .banner { position: relative; height: 400px; background-image: url('../../public/ressources/images/career/banner.jpg'); background-position: center center; background-repeat: no-repeat; background-size: cover; }
    .bgText {background-color: rgb(var(--ligthGray)); padding: 100px;}
    .futurImg { background-image: url('../../public/ressources/images/career/citation.jpg'); background-position: center center; background-repeat: no-repeat; background-size: cover; }
    .futurBG { position: relative; width: 100%; background-color: black; padding: 0px 50px; height: 100%; }
    .futurAlignText { position: relative; top:50%; left: 50%; transform: translate(-50%,-50%);}
    .futurTitle { color: rgb(var(--primary)); font-family: TxtOffBDI; text-transform: uppercase;  }
    .futurText { font-family: TxtOffRe; margin-top: 20px; color: white; }
    /*Region section 3*/
        .electrikText { text-align: center; color: #fff; padding: 20px 0px; font-size: 24px; font-weight: 100; line-height: normal;}
        .BGBloc4 {position:relative;  height: 100%; padding: 10px 0px 10px 0px; background-image: url('../../public/ressources/images/truckElectrik/bloc3BG.jpg'); background-repeat: no-repeat; background-size: cover; background-position: center center;}
        .boxForm { padding: 0px 350px; }
        .realization { padding: 25px 0px; }
        .form input { color: white; background-color: rgba(17,17,17,1); padding: 10px 20px; height: 50px; border: none; font-weight: 100; font-size: 24px;  width: 90%;}
        .form select { color: white; background-color: rgba(17,17,17,1); padding: 10px 20px; height: 50px; border: none; font-weight: 100; font-size: 24px;  width: 90%;}
        .form .v-text-field input { color: white; background-color: rgba(17,17,17,1) !important; padding: 10px 20px; height: 50px; border: none; font-weight: 100; font-size: 24px;  width: 90%;}
        .inputForm { padding: 20px; }
        #ElectrikPage a {text-decoration: none; color:white;}
        #fourthBloc { padding: 100px 0px !important; }
        #fourthBloc button { margin-top:40px; margin-right: auto; margin-left: auto; font-size:24px; display: block; min-width: 200px; padding:20px; background-color: rgb(var(--secondary)); font-weight: 700; text-transform: uppercase; }
        #fourthBloc button a { color: #FFF; font-family: TxtOffBDI; }
        #fourthBloc button:hover {box-shadow: 0px 0px 10px rgb(var(--primary)); cursor: pointer;}
        .errorMsg { color: rgb(var(--primary)); font-size: 14px; font-family: TxtOffRe; margin-top: 5px; padding-left: 0px; }
    /*#endregion */
    @media handheld, only screen and (max-width: 600px) {}
    @media handheld, only screen and (max-width: 960px) {
        .boxForm { padding: 0px 20px !important; }
        .form input { width: 100%; }
        .form select { width: 100%; }
        .boximg {max-width: 150px;}
    }
    @media handheld, only screen and (max-width: 1279px) {}
    @media handheld, only screen and (max-width: 1378px) {}
</style>
<script>

export default {
name: 'getPrice',
data:()=>({
    dealers: null,
    sendForm: null, // send, error, pending
    envoiEnCours: false,
    errors: {
        telephone: '',
        email: '',
    },
    form: {
        prenom: '',
        nom: '',
        serialNumber: '',
        function: '',
        truckChoice: '',
        compagnie: '',
        telephone: '',
        town: '',
        email: '',
        address: '',
        comment: '',
        succursale: '',
    }
}),
mounted() {
    this.dealersJsonRead();
},
methods:{
    /** Lecture du JSON des concessionnaires */
    dealersJsonRead: async function () {
        try {
            const response = await fetch('/ressources/json/dealers.json');
            if (!response.ok) { throw new Error('Failed to fetch'); }
            this.dealers = await response.json();
        } catch (error) {
            console.error('Error loading dealers JSON:', error);
        }
    },
    /** Formate le téléphone en (XXX) XXX-XXXX et bloque les non-chiffres */
    formatTelephone: function() {
        let digits = this.form.telephone.replace(/\D/g, '');
        if (digits.length > 10) { digits = digits.substring(0, 10); }
        let formatted = '';
        if (digits.length > 0) { formatted = '(' + digits.substring(0, 3); }
        if (digits.length >= 3) { formatted += ') '; }
        if (digits.length > 3) { formatted += digits.substring(3, 6); }
        if (digits.length >= 6) { formatted += '-'; }
        if (digits.length > 6) { formatted += digits.substring(6, 10); }
        this.form.telephone = formatted;
        this.errors.telephone = '';
    },
    /** Valide le format du courriel */
    validateEmail: function() {
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!this.form.email) {
            this.errors.email = 'Le courriel est requis.';
            return false;
        }
        if (!regex.test(this.form.email)) {
            this.errors.email = 'Le format du courriel est invalide.';
            return false;
        }
        this.errors.email = '';
        return true;
    },
    /** Valide le téléphone (10 chiffres avec indicatif régional) */
    validateTelephone: function() {
        const digits = this.form.telephone.replace(/\D/g, '');
        if (!digits) {
            this.errors.telephone = 'Le numéro de téléphone est requis.';
            return false;
        }
        if (digits.length < 10) {
            this.errors.telephone = 'Le numéro doit contenir 10 chiffres (indicatif régional inclus).';
            return false;
        }
        this.errors.telephone = '';
        return true;
    },
    /** Valide tout le formulaire avant soumission */
    validateAndSubmit: function() {
        const telValid = this.validateTelephone();
        const emailValid = this.validateEmail();
        if (telValid && emailValid) {
            if (this.envoiEnCours) return
            this.envoiEnCours = true
            try {
                window.fbq?.('track', 'Lead', { content_name: 'evaluation-vehicule' })
            } catch (e) { /* le tracking ne doit jamais bloquer l'envoi */ }
            setTimeout(() => this.$refs.formGetPrice.submit(), 300)
            setTimeout(() => { this.envoiEnCours = false }, 5000)
        }
    },
},
components: { }
}
</script>